import type { ReactElement } from "react";

import { RefreshCw } from "lucide-react";

/** Calm page-and-reload mark for the full-page error card. */
export function ErrorPageIllustration(): ReactElement {
  return (
    <div className="relative mx-auto h-36 w-44" role="img" aria-label="A page ready to reload">
      <svg viewBox="0 0 176 144" className="h-full w-full" aria-hidden="true">
        <rect x="4" y="18" width="168" height="112" rx="32" fill="#E6F0DC" />
        <circle cx="36" cy="40" r="8" fill="#C1E899" />
        <rect x="46" y="28" width="76" height="94" rx="10" fill="#ffffff" />
        <rect
          x="46"
          y="28"
          width="76"
          height="94"
          rx="10"
          fill="none"
          stroke="#55883B"
          strokeWidth="2"
        />
        <path d="M100 36c8 1 14 9 12 18-8-1-16-8-12-18z" fill="#55883B" />
        <path
          d="M108 42c2 5 0 9-3 11"
          fill="none"
          stroke="#E6F0DC"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <rect x="60" y="56" width="48" height="7" rx="3.5" fill="#C1E899" />
        <rect x="60" y="72" width="36" height="7" rx="3.5" fill="#E6F0DC" />
        <rect x="60" y="88" width="42" height="7" rx="3.5" fill="#E6F0DC" />
      </svg>
      <span className="absolute bottom-1 right-2 flex h-11 w-11 items-center justify-center rounded-full bg-brand-grass text-white shadow-md">
        <RefreshCw className="h-5 w-5" aria-hidden="true" />
      </span>
    </div>
  );
}
